import React from 'react'
import { Div, H6, Section } from '@driftt/tide-core'
import { Icon } from '@driftt/tide-icons'

const PropertyItem = ({ name, value }) => {
  return (
    <Div className="contact-details--attributes-card-field">
      <span className="field-key">
        <Div className="contact-details--attribute-truncated">
          {name}
        </Div>
      </span>
      <span className="field-value">
        {value}
      </span>
    </Div>
  )
}

const PropertyGroupCard = ({ iconName, groupName, properties }) => {
  return (
    <Div className="contact-details--attributes-card">
      <Div className="contact-details--attributes-card-header">
        <Div className="contact-details--attributes-card-header-icon">
          <Icon name={iconName} width={16} />
        </Div>
        <Div className="contact-details--attributes-card-header-text">
          <H6>{groupName}</H6>
        </Div>
      </Div>
      <Section className="contact-details--attributes--properties-container">
        {properties.map(property =>
          <PropertyItem name={property.displayName} value={property.value} key={property.name} />
        )}
      </Section>
    </Div>
  )
}

export default PropertyGroupCard
